import styled, { css } from 'styled-components';
import { LogoLink as LogoLinkComponent } from '../../LogoLink';
import { desktopMinWidthBP } from '../constants';

export const LogoLink = styled(LogoLinkComponent)(
  ({ theme }) => css`
    svg {
      padding: ${theme.sz.s0} calc(100% / 8);
    }

    width: ${theme.sz.s12};
    height: ${theme.sz.s12};

    @media (min-width: ${desktopMinWidthBP}) {
      width: ${theme.sz.s20};
      height: ${theme.sz.s20};
    }
  `,
);
